import { createSelector } from 'reselect';
import { rootSelector } from '../../../root-selector';

export const rolesSelector = createSelector(
  rootSelector,
  state => state.authenticationSlice.rolesSlice && state.authenticationSlice.rolesSlice.roles
);
